import React, { useEffect, useState } from 'react'
import { motion } from 'framer-motion';
import Header from '../../../Components/Header'
import Seo from '../../../Components/SeoComponent/Seo'
import { Button, InputWithLabel } from '../../../Components/Tags/Tags';
import Loader from '../../../Loader';
import { digitalAadharService, fetchProfile, sendDownloadAadharOtp } from '../../../Services/ApiTestService/aadharTestService';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { Link } from 'react-router-dom';
import { FaCopy, FaDownload, FaIdCard, FaLink } from 'react-icons/fa';
import { IoArrowBackCircleOutline } from "react-icons/io5";
import { digitalAadharData, digitalaadharVerifyData } from '../data2';
import { aadharVerifyData } from '../Data';
import { useService } from '../../../context/ServiceContext';
import ConfirmPopUp from '../../../Components/ConfirmPopUp/ConfirmPopUp';
const isValidAadhar = (number) => {
    const regex = /^\d{12}$/;
    return regex.test(number);
};
const AadharDigitalKyc = () => {
    const [aadharNumber, setAadharNumber] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const { serviceName } = useService();
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState({ aadhar: "", otp: "", type: "error" });
    const [profileData, setProfileData] = useState(null)
    const [isLoading, setIsLoading] = useState(false);
    const [isKycDone, setIsKycDone] = useState(false);
    const [aadharUrlData, setAadharUrlData] = useState();
    const [isUrlGenerated, setIsUrlGenerated] = useState(false);
    const [aadharData, setAadharData] = useState(null);
    const [transactionId, setIsTransactionId] = useState(null);
     
    const handleSubmit = async () => {
        setMessage({ aadhar: '', otp: '', mobile: '', firstName: '', lastName: '', email: '', type: 'error' });



        if (firstName === "") {
            setMessage({ firstName: "First Name is required", type: 'error' });
            return;
        }
        if (lastName === "") {
            setMessage({ lastName: "Last Name is required", type: 'error' });
            return;
        }
        if (email === "") {
            setMessage({ email: "Email is required", type: 'error' });
            return;
        }
        if (aadharNumber === "") {
            setMessage({ aadhar: "Aadhar number is required", type: 'error' });
            return;
        }

        if (!isValidAadhar(aadharNumber)) {
            setMessage({ aadhar: "Invalid Aadhar number", type: 'error' });
            return;
        }
        if (mobile === "") {
            setMessage({ mobile: 'Mobile number is required.', type: 'error' })

        } else if (!/^[6-9]\d{9}$/.test(mobile)) {
            setMessage({ mobile: 'Enter a valid 10-digit mobile number.', type: 'error' })
        }

        let payload = {};
        if (!isUrlGenerated) {
            payload = {

                "api_id": profileData?.user_id,
                "api_key": profileData?.api_key,
                "token_id": profileData?.token_id,
                "aadhar": aadharNumber,
                "methodName": "generateUrl",
                "lastName": lastName,
                "firstName": firstName,
                "mobile": mobile,
                "emailId": email,

            };
        } else {
            payload = {

                api_id: profileData?.user_id,
                api_key: profileData?.api_key,
                token_id: profileData?.token_id,
                "transactionId": transactionId,
                "methodName": "fetchDetails"

            };
        }
        try {
            setIsLoading(true)

            let response = await digitalAadharService(payload);
        
            setIsLoading(false)
            if (response.status.code === 200 && payload.methodName === "generateUrl") {
                showSuccessToast(response.message || response.status.message || response.data.message || "Aadhar Url Generated Successfully");
                setIsUrlGenerated(true);
                setIsTransactionId(response.data.transactionId);
                setAadharUrlData(response.data)

            } else if (response.status.code === 200 && payload.methodName === "fetchDetails") {
                showSuccessToast(response.message || response.status.message || response.data.message || "Aadhar Url Generated Successfully");
                setAadharData(response.data);
                setIsUrlGenerated(false);
                setIsTransactionId(null);
                setAadharUrlData(null)
            } else {
                showErrorToast(response?.message || response?.status.message || response?.data.message || "an unexpected error occur while fetching data")
            }

        } catch (error) {
        
            setIsLoading(false);
        }




    };
    function closeKycMemnu() {
        setIsKycDone(false);
        setIsOpen(true)
    }
    function handleCopyText(data) {
        window.navigator.clipboard.writeText(JSON.stringify(data));
        showSuccessToast('Copied successfully')
    }
    function handleOpenModal() {
        setIsKycDone(true)
    }
    useEffect(() => {
        const fetchProfileData = async () => {
            try {
                setIsLoading(true);
                const response = await fetchProfile();
                setProfileData(response.data);
            } catch (error) {
                console.error("Error fetching profile data:", error);
                showErrorToast("Failed to fetch profile data.");
            } finally {
                setIsLoading(false);
            }
        };

        fetchProfileData();
    }, []);
    return (
        <>
            {isLoading && <Loader />}
            <Header heading={serviceName} />
            <Seo title={serviceName} />
            <ConfirmPopUp visible={isOpen} onClose={() => setIsOpen(false)} onConfirm={handleSubmit} title={'Are you sure want to close ?'} />
            <OpenDigitalKyc url={aadharUrlData!==null ? aadharUrlData?.kycUrl :""} onClose={closeKycMemnu} isOpen={isKycDone} />
            <div>

                <div className="col-span-2 md:col-span-6 flex justify-end">
                    <Link
                        to="/TestMaster"
                        className="flex items-center gap-1 text-white bg-green-600 hover:bg-green-700 px-1 py-1 rounded-md font-semibold shadow-md transition duration-300"
                    >
                        <span>Go Back</span>
                        <IoArrowBackCircleOutline size={24} />
                    </Link>
                </div>
                <div className='flex items-center gap-2 py-2 bg-gray-100 shadow-sm'>

                    <div>
                        <InputWithLabel
                            label={"First Name"}
                            placeholder={"Enter First Name "}
                            required={true}
                            value={firstName}
                            onChange={(e) => setFirstName(e.target.value)}
                        />
                        {message.firstName && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.firstName}
                            </p>
                        )}
                    </div>
                    <div>
                        <InputWithLabel
                            label={"Last Name"}
                            placeholder={"Enter Last Name "}
                            required={true}
                            value={lastName}
                            onChange={(e) => setLastName(e.target.value)}
                        />
                        {message.lastName && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.lastName}
                            </p>
                        )}
                    </div>
                    <div>
                        <InputWithLabel
                            label={"Mobile"}
                            placeholder={"91******** "}
                            required={true}
                            value={mobile}
                            type={'number'}
                            onChange={(e) => setMobile(e.target.value)}
                        />
                        {message.mobile && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.mobile}
                            </p>
                        )}
                    </div>
                    <div>
                        <InputWithLabel
                            label={"Email"}
                            placeholder={"Enter email address "}
                            required={true}
                            value={email}
                            type={'email'}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                        {message.email && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.email}
                            </p>
                        )}
                    </div>

                    <div>
                        <InputWithLabel
                            label={"Aadhar Number"}
                            placeholder={"Enter aadhar number "}
                            required={true}
                            value={aadharNumber}
                            onChange={(e) => setAadharNumber(e.target.value)}
                        />
                        {message.aadhar && (
                            <p className={`text-sm ${message.type === 'error' ? 'text-red-600' : 'text-green-600'}`}>
                                {message.aadhar}
                            </p>
                        )}
                    </div>



                    <div className='mt-4'>
                        <Button type={'button'} text={"Verify"} onClick={handleSubmit} />
                    </div>

                </div>
                <div>
                    {aadharUrlData !== null ?
                        <AadharInfo aadharUrlData={aadharUrlData} handleKyc={handleOpenModal} />

                        : ""}
                </div>
                <div>
                    {aadharData !== null ?
                        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6">
                            <div><AadharCard user={aadharData.data} /></div>
                            <div>
                                <h3 className="bg-green-200 text-xl font-bold my-2 rounded p-2">Api Response </h3>
                                <pre className="bg-black relative text-green-500 p-4 rounded text-sm overflow-auto max-h-[600px]">
                                    <FaCopy className="absolute top-2 cursor-pointer right-2  bg-white p-1 rounded-md font-bold text-2xl" onClick={() => handleCopyText(aadharData)} />
                                    {JSON.stringify(aadharData, null, 2)}
                                </pre>
                            </div>
                        </div>

                        : ""}
                </div>

                <AadhaarInstructions />
            </div>
        </>
    );
};


const AadhaarInstructions = () => {
    return (
        <div className="max-w-5xl mx-auto p-5 bg-white shadow-lg rounded-lg border border-gray-200">
            <h1 className="text-xl font-semibold mb-3 text-red-600 border-b pb-2">Aadhar Digital Kyc Instructions</h1>
            <ol className="list-decimal pl-5 space-y-3 text-gray-700 text-sm">


                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>First Create Link for kyc.</li>
                        <li>Share Link or click link for kyc. </li>
                        <li>Don't fetch details until kyc not done.</li>
                    </ul>
                </li>
                <li>
                    <strong>Important:</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Use only your first name (first four letters)</li>
                        <li>If name has fewer than 4 letters, use the full name</li>
                        <li>No spaces or symbols in the password</li>
                    </ul>
                </li>
                <li>
                    <strong>Having Issues?</strong>
                    <ul className="list-disc pl-5 mt-1 text-gray-600">
                        <li>Double-check name and year format</li>
                        <li>Ensure your PDF viewer supports secure files</li>
                    </ul>
                </li>
                <li>
                    <strong>Need Help?</strong> Reach out to support or visit the official Aadhaar help center.
                </li>
            </ol>
        </div>
    );
};



function AadharInfo({ aadharUrlData ,handleKyc}) {
    const [copied, setCopied] = useState(false);

    const handleCopy = (text) => {
        navigator.clipboard.writeText(text);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    if (!aadharUrlData) return null;

    return (
        <div className="bg-white p-6 rounded-lg shadow-md space-y-4 max-w-xl mx-auto mt-10 border border-gray-200">
            <div className="flex items-center justify-between">
                <h2 className="text-xl font-bold text-gray-800">Digilocker Info</h2>
                <button
                    onClick={() => handleCopy(aadharUrlData.kycUrl)}
                    className="flex items-center gap-2 text-blue-600 hover:text-blue-800 transition"
                >
                    <FaCopy />
                    <span className="text-sm font-medium">Copy Link</span>
                </button>
            </div>
            {copied && <p className="text-green-600 text-sm">Link copied!</p>}

            <div className="space-y-2 text-gray-700">
                <p><strong>Message:</strong> Digilocker URL generated successfully.</p>

                <p><strong>Digilocker URL:</strong>
                    <a href={aadharUrlData.url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline ml-2">
                        {aadharUrlData.url}
                    </a>
                </p>
            </div>

            <Link
                to={"#"}
                onClick={handleKyc}
                className="inline-flex items-center gap-2 text-white bg-blue-900 hover:bg-green-700 px-4 py-2 rounded-md font-semibold shadow transition duration-300"
            >
                <span>Verify KYC</span>
                <FaLink size={20} />
            </Link>
        </div>
    );
}


const OpenDigitalKyc = ({ isOpen, onClose, url }) => {
     const dropIn = {
        hidden: {
            y: "-100vh",
            opacity: 0,
        },
        visible: {
            y: "0",
            opacity: 1,
            transition: {
                duration: 0.1,
                type: "spring",
                damping: 25,
                stiffness: 500,
            },
        },
        exit: {
            y: "100vh",
            opacity: 0,
        },
    };
    return (
        <motion.div
            initial="hidden"
            animate={isOpen ? "visible" : "hidden"}
            exit="exit"
            variants={dropIn}
            className={` shadow-lg rounded-lg border backdrop-blur-2xl bg-neutral-50  border-blue-700 w-full h-1/3 max-w-lg fixed inset-0 m-auto p-3 `}
        >
            <div className="bg-white rounded-lg shadow-lg w-full md:max-w-3xl overflow-y-auto max-h-[100vh]" >

                <iframe
                    src={url}
                    width="600"
                    height="400"
                    title="Example Website"
                />






                {/* Recent Activity Section */}

                <div className="flex justify-center mt-4">

                    <button
                        className="bg-green-500 text-white p-2 rounded hover:bg-red-700"
                        onClick={onClose} // This should close the modal
                    >
                        Continue
                    </button>
                </div>
            </div>
        </motion.div >
    )
}




const AadharCard = ({ user }) => {
    return (
        <div className="w-[350px] border shadow-xl rounded-md overflow-hidden font-sans bg-white">

            <div className="bg-gradient-to-r from-orange-500 via-white to-green-500 p-2 flex justify-between items-center">
                <img src="" alt=" Logo" className="w-8 h-8" />
                <h2 className="text-sm font-bold text-center flex-1">Power By IDSPay</h2>
            </div>
            <p className='text-center font-bold '>{user.maskedAdharNumber}</p>
            {/* Body */}
            <div className="flex p-4">
                {/* User Photo */}
                <img
                    src={`data:image/jpeg;base64,${user.image}`}
                    alt="User"
                    className="w-24 h-28 border object-cover mr-4"
                />

                {/* User Info */}
                <div className="text-sm space-y-1">
                    <div><strong>Name:</strong> {user.name}</div>
                    <div><strong>careOf:</strong> {user.careOf}</div>
                    <div><strong>DOB:</strong> {user.dob}</div>
                    <div><strong>Gender:</strong> {user.gender}</div>
                    <div>
                        <strong>Address: </strong>{user.address.street + "," + user.address.dist + "," + user.address.pc + "," + user.address.state + "," + user.address.country}

                    </div>
                </div>

            </div>


        </div>
    );
};



export default AadharDigitalKyc
